// mitt事件总线
import mitt from 'mitt';

const mitter = mitt();
export default mitter;
